import objectAssign from 'object-assign';
import { sharedInitialState } from '../store/initialState';
import {
  RENEW_AS_OF_NOW,
  REDIRECT_TO_PAGE_NOT_FOUND,
  REDIRECT_TO_PAGE_FEATURE_UNAVAILABLE,
  HIDE_HELP_ABOUT_THIS_PAGE,
  UPDATE_SEARCH_COLUMN,
} from 'actions/shared';
import { PUBNUB_HEALTH_STATE } from 'actions/networkHealthStatus';

const reducer = (state = sharedInitialState, action) => {
  switch (action.type) {
    case RENEW_AS_OF_NOW:
      // console.log('current asOfNow:', state.asOfNow);
      return objectAssign({}, state, {
        asOfNow: new Date(),
      });

    case REDIRECT_TO_PAGE_NOT_FOUND:
      return objectAssign({}, state, {
        redirectToPageNotFound: action.data,
      });

    case REDIRECT_TO_PAGE_FEATURE_UNAVAILABLE:
      return objectAssign({}, state, {
        redirectToPageFeatureUnavailable: action.data,
      });

    case HIDE_HELP_ABOUT_THIS_PAGE:
      return objectAssign({}, state, {
        hideHelpAboutThisPage: action.data,
      });

    case PUBNUB_HEALTH_STATE.CLIENT: {
      const newHealthState = objectAssign({}, state.pubnubConnectionStatus, {
        isClientHealthy: action.data,
      });

      return objectAssign({}, state, {
        pubnubConnectionStatus: newHealthState,
      });
    }

    case PUBNUB_HEALTH_STATE.SERVER: {
      const newHealthState = objectAssign({}, state.pubnubConnectionStatus, {
        isServerHealthy: action.data,
      });

      return objectAssign({}, state, {
        pubnubConnectionStatus: newHealthState,
      });
    }

    case PUBNUB_HEALTH_STATE.HEARTBEAT_RECEVIED: {
      const newHealthState = objectAssign({}, state.pubnubConnectionStatus, {
        lastHeartbeatUtc: action.data,
      });

      return objectAssign({}, state, {
        pubnubConnectionStatus: newHealthState,
      });
    }

    case PUBNUB_HEALTH_STATE.SECONDS_TO_AUTO_REFRESH: {
      const newHealthState = objectAssign({}, state.pubnubConnectionStatus, {
        secondsToAutoRefresh: action.data,
      });

      return objectAssign({}, state, {
        pubnubConnectionStatus: newHealthState,
      });
    }

    case PUBNUB_HEALTH_STATE.SECONDS_SINCE_PUBNUB_DOWN: {
      const newHealthState = objectAssign({}, state.pubnubConnectionStatus, {
        secondsSincePubnubDown: action.data,
      });

      return objectAssign({}, state, {
        pubnubConnectionStatus: newHealthState,
      });
    }

    case UPDATE_SEARCH_COLUMN: {
      return objectAssign({}, state, { updateSearchColumn: action.data });
    }

    default:
      return state;
  }
};

export default reducer;
